// extracted by mini-css-extract-plugin
export default {"top":"NoticeBoard_top__B+zcm","box":"NoticeBoard_box__1p5Yn","addButton":"NoticeBoard_addButton__aFfwM"};